import { render, staticRenderFns } from "./FileShareCopySetting.vue?vue&type=template&id=6d82b3ca&scoped=true"
import script from "./FileShareCopySetting.vue?vue&type=script&lang=js"
export * from "./FileShareCopySetting.vue?vue&type=script&lang=js"
import style0 from "./FileShareCopySetting.vue?vue&type=style&index=0&id=6d82b3ca&prod&lang=scss&scoped=true"
import style1 from "./FileShareCopySetting.vue?vue&type=style&index=1&id=6d82b3ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82b3ca",
  null
  
)

export default component.exports